import React from 'react'

interface TagProps {
  tag: string
  className?: string
}

const Tag: React.FC<TagProps> = ({ tag, className }) => {
  return (
    <span
      className={
        className
          ? className
          : 'py-2.5 px-4 border border-brown-hot rounded-full text-[14px] font-semimedium'
      }
    >
      {tag}
    </span>
  )
}

export default Tag
